module.exports = __webpack_public_path__ + "img/menu-deposit-white.d569afa2.svg";